import { Button, Dialog, Typography } from '@equinor/eds-core-react';
import * as Styled from './ConfirmDialog.styled';

export const ConfirmDialog = ({
  isOpen,
  header,
  message,
  danger,
  confirmAction,
  setIsOpen,
}: {
  isOpen: boolean;
  header?: string;
  message: string;
  danger: boolean;
  confirmAction: () => void;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <Styled.WideDialog open={isOpen}>
      {header && <Dialog.Header>{header}</Dialog.Header>}
      <Dialog.CustomContent>
        <Typography variant="body_short">{message}</Typography>
      </Dialog.CustomContent>
      <Styled.Actions>
        <Button
          variant="outlined"
          color={danger ? 'danger' : undefined}
          onClick={() => setIsOpen(false)}
        >
          {'Cancel'}
        </Button>
        <Button color={danger ? 'danger' : undefined} onClick={confirmAction}>
          {danger ? 'Delete' : 'Ok'}
        </Button>
      </Styled.Actions>
    </Styled.WideDialog>
  );
};
